
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import rapidas from './pregunta-responder-predefinidas.vue';
    import verificar from './pregunta-responder-aplicar.vue';
    import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            rapidas,
            verificar
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }
        @Prop()
        public Pregunta: Pregunta;
        @Watch( 'Pregunta', { immediate: true })
        onPregunta()
        {
            if ( this.Pregunta.Respuesta )
            {
                this.Aplicado = true;
            }
        }

        public Respuesta: string = '';

        public Aplicando: boolean = false;
        public Aplicado: boolean = false;
        AplicarRespuesta( item: RespuestaPredefinida )
        {
            if ( item )
                this.Respuesta = item.Respuesta;

        }

        async Siguiente()
        {
            let e = await Pregunta.find( { estado: 'UNANSWERED', limit: 1 } );
            if ( e.Items.hasRows() )
            {
                this.Controlador.Vista.Modo = 'ninguno';
                this.$nextTick( () =>
                {
                    this.Controlador.PreguntaSeleccionada = e.Items[0];
                    this.Controlador.Vista.Modo = 'pregunta';
                } );

            } else
            {
                Utiles.Notificaciones.Completado( '¡No hay mas preguntas!' );
                this.Controlador.Vista.Modo = 'preguntas';
            }
        }
    }
